import BaseModel from '../core/BaseModel'
//import gql from 'graphql-tag'
export default class VerModel extends BaseModel {
    constructor() {
        super({ 
                name: "ver",
                tableName: 'users', 
                label: "Danh Sách Ver",
                display_key: 'fullname', 
                default_order: { key: 'updated_at', direction: 'asc' } }, 
            {
            stt: {
                name: "stt",
                label: "STT",
                type: "Computed",
                computed: (data, index) => {
                    data.stt = index + 1;
                },
                // display: { list: true, add: false, edit: false }
            },
            id: { 
                name: 'id', 
                type: "Uuid", 
                label: 'ID', 
                primaryKey: true, 
                // edit: {
                //     add: false, 
                //     edit: false 
                // }, 
                display: false
            },
            avatar: {
                name: 'avatar', 
                type: "Image",
                label: 'Avatar',
                // inputOptions: { mode: 'multiple' },  
                // display: false,
                accessable: "image/*"
            },
            code : { 
                name: 'code', 
                type: "String", 
                label: 'Mã Ver', 
                sortable: false, 
                filter: { type: 'input', match: 'contains'},
            },
            fullname: {
                name: 'fullname', 
                type: "String",
                label: 'Tên Ver',
                filter: { type: 'input', match: 'contains'},
                // display: false
            },
            phone : {
                name: 'phone', 
                type: "String", 
                label: 'Số điện thoại', 
                sortable: false,
                filter: { 
                    type: 'input', 
                    match: 'contains' 
                },
            }
        },)
    }

}